import { Record, List } from 'immutable';

const ManufacturerRecord = Record({
    manufacturer: '',
    models: List([]),
});

class Manufacturer extends ManufacturerRecord {}

export default Manufacturer;
